import React from 'react';
import CalendarDesktop from './desktop/CalendarDesktop';
import CalendarMobile from './mobile/CalendarMobile';
import { CalendarProps } from './types';

const Calendar: React.FC<CalendarProps & { isMobile?: boolean; userId?: string | null }> = ({ 
  isMobile = false,
  userId,
  ...props 
}) => {
  if (isMobile) {
    return <CalendarMobile {...props} userId={userId} />;
  }
  return <CalendarDesktop {...props} userId={userId} />;
};

export default Calendar;
